import React from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import ModalNoClose from "../modal.no.close";

const SessionTimeoutModal = ({ open, remainingSeconds }) => {
  const safeSeconds = Math.max(0, Math.ceil(Number(remainingSeconds) || 0));

  return (
    <ModalNoClose
      open={open}
      title="Session timeout"
      onClose={() => {}}
      disableBackdropClick
      disableEscapeKeyDown
    >
      <Box
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "16px",
        }}
      >
        <Typography variant="body1" align="center">
          You have been inactive and will be signed out in:
        </Typography>
        <Typography
          variant="h3"
          component="p"
          data-testid="session-timeout-countdown"
          align="center"
          style={{ fontWeight: 600 }}
        >
          {safeSeconds}
        </Typography>
        <Typography variant="body2" color="textSecondary" align="center">
          Move the mouse or use the keyboard to stay signed in.
        </Typography>
      </Box>
    </ModalNoClose>
  );
};

export default SessionTimeoutModal;
